<template>
<div class="animated fadeIn">

	<div class="row">
		<div class="col-lg-12 form-group">
			<h3 class="animated slideInDown"><fa-icon icon="route" /> Trechos</h3>
		</div>
	</div>

	<div class="row">

		<div class="col-sm-4 form-group">

			<!-- <pre>{{form.periodo}}</pre> -->
			<date-picker ref="date"
						:input-class="'form-control form-control-sm '"
						v-model="form.periodo"
						format="DD/MM/YYYY"
						range
						:shortcuts="false"
						:confirm="_isMobile"
						type="date"
						lang="pt-br"></date-picker>
		</div>

		<div class="col-sm-3 form-group">
			<button :disabled="form.equipamento == '' && form.periodo.length < 2"
					@click="carregaTrecho()"
					class="btn btn-sm btn-block btn-success">
				<fa-icon icon="sync-alt"/> CARREGAR
			</button>
		</div>

		<div class="col-sm-5 form-group">

			<button @click="exibirUTC = !exibirUTC"
					v-if="trechos.length > 0"
					:class="{'btn-dark' : exibirUTC, 'btn-outline-dark': !exibirUTC}"
					class="btn btn-sm float-right">
				<fa-icon :icon="['far', 'circle']" v-show="!exibirUTC"/>
				<fa-icon icon="check-circle" v-show="exibirUTC"/>
				Exibir UTC
			</button>

			<button @click="clicReenviar"
					v-if="_getPrivilegio(30) && trechos.length > 0"
					style="margin-right: 8px"
					class="btn btn-outline-dark btn-sm float-right">
				<fa-icon icon="paper-plane"/> Reenviar
			</button>

			<button @click="$refs.modalNovoTrecho.show()"
					style="margin-right: 8px"
					class="btn btn-outline-dark btn-sm float-right">
				<fa-icon icon="plus"/> Novo
			</button>
		</div>
	</div>

	<h4 v-if="buscou && trechos.length == 0">
		Nenhum trecho encontrado.
	</h4>

	<div v-if="trechos.length > 0" >
		<flTabelaTrecho @clickPosicoes=clickPosicoes
						@clickExcluir="clickExcluir"
						@click-editar="clickEditar"
						:trechos="trechos"
						:data="data"
						:exibirUTC="exibirUTC" />
	</div>

	<flModal width="90%" ref="modalPosicao">
		<template v-slot:header><fa-icon icon="map-marker-alt" /> Posições</template>
		<fl-posicao ref="posicoes" :trecho="trecho" :posicoes="this.posicoes" :form="form" />
	</flModal>

	<fl-modal width="40%" ref="modalNovoTrecho">
		<template v-slot:header><fa-icon icon="plus" /> Novo</template>
		<fl-novo 	:idEquipamento="form.equipamento.id"
					:imei="form.equipamento.imei"
					@salvou-trecho="(trecho) => {
						$refs.modalNovoTrecho.hide();
						this.carregaTrecho();
					}"
					ref="novoTrecho"  />
	</fl-modal>

	<fl-modal width="40%" ref="modalReenviar">
		<template v-slot:header><fa-icon icon="paper-plane" /> Reenviar</template>
		<fl-reenvio ref="CPReenvio" />
	</fl-modal>
	<EditarTrecho
		ref="modalEditarTrechoRef"
		@editou-trecho="carregaTrecho"
	/>
</div>
</template>

<script>
import _ from 'lodash'
import flPosicao from './posicoes'
import flTabelaTrecho from './tabela-trecho.vue'
import flNovo from './novo.vue'
import flReenvio from '../reenvio.vue'
import flModal from '../../../../components/modal/main.vue'
import moment from 'moment'
import axios from '../../../../routers/axios'
import calculo from '../../../../library/calculo'
import EditarTrecho from './editarTrecho.vue'


export default {

	components: {
		flPosicao,
		flTabelaTrecho,
		flReenvio,
		flNovo,
		flModal,
		EditarTrecho,
	},

	data() {
		return {
			form: {
				equipamento: "",
				cliente: "0",
				periodo: [],
			},

			exibirUTC: true,
			buscou: false,
			equipamentos: [],
			data: "",
			clientes: [],
			trechos: [],
			posicoes: [],
			trecho: {}
		};
	},

	computed: {
		_trechos() {
			if (this.data == "") {
				return this.trechos;
			} else {
				return _.filter(this.trechos, o => {
					return o._data == this.data;
				});
			}
		}
	},

	mounted() {
		axios.get(this._getUrl("api/equipamento")).then(response => {
			this.load = false;
			this.equipamentos = _.orderBy(response.data, ["prefixo"], ["asc"]);
		});

		axios.get(this._getUrl("api/cliente")).then(response => {
			this.clientes = _.orderBy(response.data, ["nome"], ["asc"]);
		});
	},

	methods: {
		clickEditar(trecho){
			this.$nextTick(() => {
				this.$refs.modalEditarTrechoRef.carregar(
					trecho
				)
			})
		},
		carregaDados(equipamento){
			this.form.equipamento = equipamento
		},

		clickExcluir(item) {

			let text = `<h4>Deseja excluir esse trecho?</h4>
						<br>
						<p class="text-danger">
							Acionamento: ${item.acionamento}.
						</p>`

			this.$modalExcluir.show(text, item).then(item => {
				this.excluir(item)
			})
		},

		excluir(item) {
			axios.delete(this._getUrl(`api/equipamentotrecho/${item.id}`)).then(response => {
				this.$notify.show('success','Trecho excluído.')
				this.trechos = _.remove(this.trechos, n => {
					return n.id != item.id;
				});
			});
		},

		clicReenviar(){

			this.$refs.modalReenviar.show()

			this.$nextTick(() => {
				this.$refs.CPReenvio.carregar(
					this.form.equipamento,
					'T',
					this.form.periodo[0],
					this.form.periodo[1])
			})
		},

		clickPosicoes(item) {
			this.posicoes = [];
			this.trecho = item;

			this.$notify.loadIn('Carregando')

			const url = this._getUrl(`api/equipamentoposicao/${item.idEquipamento}/${item.acionamentoUTC}/${item.corteUTC}`)

			axios.get(url).then(response => {

				this.posicoes = response.data.map(item => {
					item.data = new moment.utc(item.dataUTC).local().format("DD/MM/YYYY HH:mm");
					item._dataUTC = new moment.utc(item.dataUTC).format("DD/MM/YYYY HH:mm");
					return item;
				});

				this.$refs.modalPosicao.show()
				this.$nextTick(() => this.$refs.posicoes.carregaMapa())
			});
		},

		carregaTrecho() {

			let data = {
				imeiEquipamento: this.form.equipamento.imei,
				inicio: this.dateToYMD(this.form.periodo[0]),
				fim: this.dateToYMD(this.form.periodo[1]),
			}

			this.$notify.loadIn('Carregando')

			const url = this._getUrl(`api/equipamentotrecho/${data.imeiEquipamento}/${data.inicio}/${data.fim}`)

			axios.get(url).then(response => {
				this.buscou = true;
				this.trechos = _.filter(response.data, o => {return !o.aberto }).map(item => {
					item._data = new moment.utc(item.acionamentoUTC).local().format("DD/MM/YYYY");
					item._dataUTC = new moment.utc(item.acionamentoUTC).format("DD/MM/YYYY");

					item.acionamento = new moment.utc(item.acionamentoUTC).local().format("HH:mm");
					item._acionamentoUTC = new moment.utc(item.acionamentoUTC).format("HH:mm");

					item.decolagem = new moment.utc(item.decolagemUTC).local().format("HH:mm");
					item._decolagemUTC = new moment.utc(item.decolagemUTC).format("HH:mm");

					item.pouso = new moment.utc(item.pousoUTC).local().format("HH:mm");
					item._pousoUTC = new moment.utc(item.pousoUTC).format("HH:mm");

					item.corte = new moment.utc(item.corteUTC).local().format("HH:mm");
					item._corteUTC = new moment.utc(item.corteUTC).format("HH:mm");
					item.exibir = false;

					item.acionamentoCorte = calculo.timeToDecimal(item.acionamentoUTC, item.corteUTC)
					item.decolagemPouso = calculo.timeToDecimal(item.decolagemUTC, item.pousoUTC)

					return item;
				});
			});
		},
	}
};
</script>



// WEBPACK FOOTER //
// src/views/equipamento/detalhe/trecho/main.vue